var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isShowBackdrop)?_c('div',{staticClass:"backdrop-component page-section",attrs:{"id":"backdrop"}},[_c('div',{staticClass:"container"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }